export const VELO_BANNER_DEFAULT = {
  displayVeloBanner: false,
  prompt: null,
  message: ''
};
